import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackBarData } from 'src/app/common/components/snackbar/model/snackbar.model';
import { SnackBarService } from 'src/app/common/components/snackbar/snackbar.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfirmDialogComponent, ConfirmDialogModel } from 'src/app/common/components/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DirtyCheck } from 'src/app/common/guards/form-deactivate.guard';
import { ShopinfoService } from 'src/app/pages/common/system/shopinfo/shopinfo.service';
import { ShopinfoModel } from 'src/app/pages/common/system/shopinfo/model/shopinfo.model';
import { DatePipe } from '@angular/common';
import { TerminalService } from 'src/app/pages/common/system/terminal/terminal.service';
import { WeeklyCashAndBankingReportService } from './weekly-cash-and-banking-report.service';
import { PermissionService } from 'src/app/auth/permission.service';

@Component({
  selector: 'app-weekly-cash-and-banking-report',
  standalone: false,
  templateUrl: './weekly-cash-and-banking-report.component.html',
  styleUrl: './weekly-cash-and-banking-report.component.scss'
})
export class WeeklyCashAndBankingReportComponent {
  title: string = "Weekly Cash & Banking";
  IsDownloading: boolean = false;
  editForm: FormGroup;
  currentYear: number;
  requestData: any = null;
  // years: number[];
  selectedYear: any;
  weeks: any[] = [];
  terminalListData: any = [];
  financialYears: any[] = []; // This will store the finYears array from API
  years: number[] = []; // This will store just the year numbers if needed separately
  isExpandedTerminal = false;
  showSelectedTerminalOnly: boolean = false;




  curFinYear!: string; // Add this to your component properties  
  permission: any;

  constructor(private router: Router,
    private builder: FormBuilder,
    private route: ActivatedRoute,
    private weeklyCashBankingReportService: WeeklyCashAndBankingReportService,
    private snackBarService: SnackBarService,
    private ShopinfoService: ShopinfoService,
    public dialog: MatDialog, private datePipe: DatePipe, private ternimalService: TerminalService, private permissionService: PermissionService) {

    const userData = sessionStorage.getItem('user');
    if (userData) {
      this.requestData = JSON.parse(userData);
      console.log('Request Data:', this.requestData);
    } else {
      console.log('Data not found in sessionStorage');
    }


    this.editForm = this.builder.group({
      // year: this.builder.control( ''),
      year: this.builder.control(null),
      week_no: this.builder.control([]),
      description: this.builder.control([]),
      decimal_places: this.builder.control([]),
      sort_by: this.builder.control('shop_name'),
      sort_order: this.builder.control('asc'),
      excludeSales: this.builder.control(0),
      excludeExpense: this.builder.control(0),
      terminalFilter: [''],

    });
    this.currentYear = new Date().getFullYear();
    // this.years = this.generateYears();

    // Automatically save to sessionStorage when form values change
    this.editForm.valueChanges.subscribe(() => {
      this.saveToSessionStorage();
    });
    this.permission = permissionService.getPagePermission("weekly-cash-and-banking-report");
    console.log(this.permission);

  }



  getCurrentWeek(weeks: any[]): any {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    return weeks.find(week => {
      const startDate = new Date(week.start_date);
      const endDate = new Date(week.end_date);
      startDate.setHours(0, 0, 0, 0);
      endDate.setHours(0, 0, 0, 0);

      return today >= startDate && today <= endDate;
    });
  }

  ngOnInit(): void {
    this.loadData();
    this.TerminalList();
    console.log(this.terminalListData)

  }


  buildRequestData(): any {
    return {
      search: {
        filters: {
          simpleSearch: [],
          advSearch: [],
          scope: {
            limit: "100",
            offset: "0"
          }
        },
        sort: [
          {
            column: "wd.year",
            order: "desc"
          }
        ]
      }
    };
  }

  loadData(): void {
    let requestData = this.buildRequestData();
    this.weeklyCashBankingReportService.getWeekNoList(requestData).subscribe(response => {
      if (response.status === 'SUCCESS') {
        this.financialYears = response.data.finYears;
        this.years = this.financialYears.map(fy => fy.year);
        this.curFinYear = response.data.curFinYear;
        const currentYearValue = parseInt(this.curFinYear.split('-')[0]);

        // Filter financialYears to include only up to the current year
        this.financialYears = response.data.finYears.filter((fy: any) =>
          fy.year <= currentYearValue
        );
        this.years = this.financialYears.map(fy => fy.year);

        if (!this.editForm.get('year')?.value) {
          const currentYearValue = parseInt(this.curFinYear.split('-')[0]); // Adjust based on curFinYear format
          const currentFinYear = this.financialYears.find(fy => fy.year === currentYearValue);

          if (currentFinYear) {
            this.editForm.get('year')?.setValue(currentYearValue, { emitEvent: false });

            let weeksArray = currentFinYear.weeks;
            const currentWeek = this.getCurrentWeek(weeksArray);

            // Filter weeks if current year
            if (currentWeek) {
              weeksArray = weeksArray.filter((week: any) => week.week_no <= currentWeek.week_no);
            }

            this.weeks = weeksArray
              .sort((a: any, b: any) => b.week_no - a.week_no)
              .map((week: any) => ({
                ...week,
                displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
              }));

            // Set current week or first week
            if (currentWeek) {
              this.editForm.get('week_no')?.setValue(currentWeek.week_no);
            } else if (this.weeks.length > 0) {
              this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
            }
          }
        }
      }
    });
  }

  // In onYearChange() method

  onYearChange(): void {
    const selectedYear = this.editForm.get('year')?.value;
    const selectedFinYear = this.financialYears.find(fy => fy.year === selectedYear);

    if (selectedFinYear) {
      let weeksArray = selectedFinYear.weeks;
      const isCurrentYear = selectedYear === parseInt(this.curFinYear.split('-')[0]); // Adjust if needed

      if (isCurrentYear) {
        const currentWeek = this.getCurrentWeek(weeksArray);
        if (currentWeek) {
          weeksArray = weeksArray.filter((week: any) => week.week_no <= currentWeek.week_no);
        }
      }

      this.weeks = weeksArray
        .sort((a: any, b: any) => b.week_no - a.week_no)
        .map((week: any) => ({
          ...week,
          displayText: `${this.padWeekNumber(week.week_no)} (${this.datePipe.transform(week.start_date, 'dd-MM-yyyy')} - ${this.datePipe.transform(week.end_date, 'dd-MM-yyyy')})`
        }));

      if (this.weeks.length > 0) {
        this.editForm.get('week_no')?.setValue(this.weeks[0].week_no);
      }
    } else {
      this.weeks = [];
      this.editForm.get('week_no')?.setValue(null);
    }
  }

  padWeekNumber(weekNo: number): string {
    return weekNo.toString().padStart(2, '0');
  }






  TerminalList(): void {

    let requestData = { search: { filters: { filter: [], scope: { offset: 0, limit: 1000000 } }, sort: [{ column: "name", order: "ASC" }] } }

    this.ternimalService.getTerminalList(requestData).subscribe(
      (response: any) => {
        this.terminalListData = [];
        var index = 0;
        response.data.terminals.forEach((item: any) => {

          var data = { index: index, item: item, selected: false };
          this.terminalListData.push(data);
          index++;
        });
        console.log(this.terminalListData)

      },
      (error: any) => {

      },
    );
  }

  getSelectedCount(sourceList: any[]): any {
    var count = 0;
    sourceList.forEach(el => {
      if (el.selected) {
        count++;
      }
    })
    return sourceList.length + '/' + ((count > 0) ? (count) : 'ALL');
  }


  sortOptions = [
    { value: 'shop_name', label: 'Shop Name' },
    { value: 'this_year_this_week_sales', label: 'This Year Sales' },
    { value: 'last_year_this_week_sales', label: 'Last Year Sales' },
    { value: 'this_week_cust_orders', label: 'This Year Customer Orders' },
    { value: 'last_year_cus_order', label: 'Last Year Customer Orders' },
    { value: 'this_week_labour_cost', label: 'This Year Labour Cost' },
    { value: 'last_year_this_week_labour_cost', label: 'Last Year Labour Cost' },
  ];

  sortOrderOptions = [
    { value: 'asc', label: 'Ascending' },
    { value: 'desc', label: 'Descending' }
  ];

  saveToSessionStorage(): void {
    // Get selected shop IDs (if none are selected, treat it as "ALL")
    const selectedShopIds = this.terminalListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.id);

    // If no shops are selected, we treat it as "ALL" (empty array means all shops)
    const shopIds = selectedShopIds.length > 0 ? selectedShopIds : [];

    // Create the data object
    const reportData = {
      year: this.editForm.get('year')?.value,
      weekNo: this.editForm.get('week_no')?.value,
      shopId: shopIds,
      sortBy: this.editForm.get('sort_by')?.value,
      sortDir: this.editForm.get('sort_order')?.value,
      isExport: 0
    };

    // Save to sessionStorage
    sessionStorage.setItem('weeklyStoreReportData', JSON.stringify(reportData));
  }




  onShopSelectionChange(): void {
    this.saveToSessionStorage();
  }



  exportClicked(): void {
    this.IsDownloading = true;
    // Use terminal codes instead of IDs
    const selectedTerminalCodes = this.terminalListData
      .filter((shop: any) => shop.selected)
      .map((shop: any) => shop.item.code);
    const selectedShops = this.terminalListData.filter((shop: any) => shop.selected);
    const terminalCodes = selectedTerminalCodes.length > 0 ? selectedTerminalCodes : [];
    const shopNames = selectedShops.length > 0 ? selectedShops.map((shop: any) => shop.item.name) : [];

    // Create the data object
    const reportData = {
      year: this.editForm.get('year')?.value,
      weekNo: this.editForm.get('week_no')?.value,
      terminalId: terminalCodes,
      shopName: this.requestData.shop_info.name,
      excludeSales: 1,
      excludeExpense: 1,
      isBankingReport: 1
    };

    if (reportData) {
      this.weeklyCashBankingReportService.getWeekNoExportList(reportData).subscribe({
        next: (response: Blob) => {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const text = reader.result as string;
              const json = JSON.parse(text);
              if (json.status === 'NO_DATA_FOUND') {
                let snackBarData: SnackBarData = {
                  message: 'No data found.',
                  title: 'No Data!!!',
                  type: 'warn'
                }
                this.IsDownloading = false;
                this.snackBarService.openSnackBar(snackBarData);
                return;
              }
            } catch (e) {
              // Not JSON, treat as file
              const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = 'weekly-cash-and-banking-report.xls';
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
              this.IsDownloading = false;
            }
          };
          reader.readAsText(response);
        },
        error: (error) => {
          this.IsDownloading = false;
          let snackBarData: SnackBarData = {
            message: 'Failed to update. Connection to the server failed',
            title: 'Failed!!!',
            type: 'error'
          }
          this.snackBarService.openSnackBar(snackBarData);
        }
      });
    }
  }



  toggleSelectAllTerminal() {
    const allSelected = this.terminalListData.every((item: any) => item.selected);
    this.terminalListData.forEach((item: any) => (item.selected = !allSelected));
    this.saveToSessionStorage();
  }

  getSelectAllIconTerminal(): string {
    const allSelected = this.terminalListData.every((item: any) => item.selected);
    const someSelected = this.terminalListData.some((item: any) => item.selected);

    if (allSelected) {
      return 'check_box';
    }
    if (someSelected) {
      return 'indeterminate_check_box';
    }
    return 'check_box_outline_blank';
  }

  get filteredTerminalListData() {
    let filteredList = this.terminalListData;
    if (this.showSelectedTerminalOnly) {
      filteredList = filteredList.filter((item: any) => item.selected);
    }
    const filter = this.editForm.get('terminalFilter')?.value?.toLowerCase() || '';
    if (filter) {
      filteredList = filteredList.filter((item: { item: { name: string; }; }) =>
        item.item.name.toLowerCase().includes(filter)
      );
    }
    return filteredList;
  }
  get selectedTerminalSourcesCount(): number {
    return this.terminalListData?.filter((item: { selected: any; }) => item.selected)?.length || 0;
  }
}
